import * as React from "react";
import Collapsible from "react-collapsible";
import axios from "axios";
import auth from "../../Auth";
import PageTitle from "../../Shared/Title";
import CandidateInformation from "../../Shared/CandidateInformation/CandidateInformation";
import CandSubPresentationInfo from "../../Shared/CandSubPresentationInfo/CandSubPresentationInfo";
import { candTriggerName } from "../../ReusableComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Comment } from "../../Shared/Comment/Comment";
import CommentHistoryBox from "../../Shared/Comment/CommentHistoryBox";
import {
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import {
  INFO_MSG_FOR_MAX_DISTANCE,
  MSG_FOR_APPROVING_OVERRIDE_REQUEST,
  MSG_FOR_REJECT_OVERRIDE_REQUEST,
  PRESENTATION_CONFIRMATION_MSG,
  PRESENTATION_SAVE_SUCCESS_MSG,
  PRESENTATION_SUBMIT_SUCCESS_MSG,
  REJECT_CANDIDATE,
  REJECT_CANDIDATE_SUCCESS_MSG,
  REQUEST_SENT_FOR_OVERRIDE,
  REQUEST_TO_OVERRIDE_APPROVED,
  REQUEST_TO_OVERRIDE_REJECTED,
  WITHDRAW_CANDIDATE,
  WITHDRAW_CANDIDATE_SUCCESS_MSG,
} from "../../Shared/AppMessages";
import {
  EntityType,
  CandidateWorkflow,
  CandSubStatusIds,
  SettingCategory,
  SETTINGS,
  AlertBoxTitle,
  LocalizationResource
} from "../../Shared/AppConstants";
import { ConfirmationModal } from "../../Shared/ConfirmationModal";
import { applySettingFilters, getClientSettingsData, history, localDateTime, successToastr } from "../../../HelperMethods";
import BillRateAndExpenses from "../BillRateAndExpenses/BillRateAndExpenses";
import FormActions from "../../Shared/Workflow/FormActions";
import {
  APP_HOME_URL,
  CAND_SUB_MANAGE_URL,
} from "../../Shared/ApiUrls";
import RejectModal from "../../Shared/RejectModal";
import { AppPermissions } from "../../Shared/Constants/AppPermissions";
import ProjectionTargetDates from "../Projection/ProjectionTargetDates";
import CandidateDistance from "../CandidateDistance/CandidateDistance";
import AlertBox from "../../Shared/AlertBox";
import { isRateLockdown } from "../../Shared/GridComponents/CommonComponents";
import CommonDataService from "../../Shared/Services/CommonDataService";
import { createTrue } from "typescript";
import { LocalizationHelper } from "../../../Localization/helpers/LocalizationHelper";

export interface SubmitPresentationFormProps {
  match: any;
}

export interface SubmitPresentationFormState {
  candidateId?: string;
  candSubmissionId?: string;
  location?: string;
  position?: string;
  candidateEmail?: string;
  candidateName?: string;
  candidatePhoneNumber?: string;
  candidateMobileNumber?: any;
  reqNo?: string;
  reqId?: string;
  status?: string;
  positionId?: string;
  jobPositionId?: string;
  locationId?: string;
  divisionId?: string;
  jobWfTypeId?: string;
  candSubDetails?: any;
  showLoader?: boolean;
  openCommentBox?: boolean;
  showSubmitModal?: boolean;
  isSubmit?: boolean;
  showWithdrawModal?: boolean;
  showRejectCandidateModal?: boolean;
  statusIntId?: any;
  reqStartDate?:any;
  targetStartDate?: any;
  targetEndDate?: any;
  isDirty?: boolean;
  clientId?: string;
  isAssignmentProjections?: boolean;
  reqEndDate?: any;
  targetDateError: boolean;
  candidateAddress?: string;
  distanceFromLocation?: any;
  showAlertForDistance: boolean;
  maxDistance?: any;
  isOverride?: any;
  approversComments?: any;
  showRejectModal?: any;
  showApprovalModal?: any;
  candPresentationInfoId?: any;
  approversCommentError?: any;
  openAlert?: boolean;
  isPilot?: boolean;
  isRateLockdown?: any;
  alertMessage?: any;
  isRateLockdownAccepted?: boolean;
  submittedVendorId?: string;
  generalReleaseEffectiveDate?: any;
  reqCreatedDate?: any;
  isForecastEnableInWf?: boolean;
}

const refCand = React.createRef<CandidateInformation>();
const refCandSubPresentation = React.createRef<CandSubPresentationInfo>();
const billRateRef = React.createRef<BillRateAndExpenses>();
const refCandDistance = React.createRef<CandidateDistance>();
class SubmitPresentationForm extends React.Component<
  SubmitPresentationFormProps,
  SubmitPresentationFormState
> {
  public alertTitle;
  constructor(props: SubmitPresentationFormProps) {
    super(props);
    this.state = {
      targetStartDate: null,
      targetEndDate: null,
      clientId: auth.getClient(),
      targetDateError: false,
      showAlertForDistance: false,
      isRateLockdownAccepted: false
    };
  }

  action: string;
  statusId: string;
  eventName: string;
  actionId: string;
  componentDidMount() {
    const { subId } = this.props.match.params;
    this.setState({ candSubmissionId: subId });
    this.getCandSubPresentationInfo(subId);
    this.getCandidateSubmissionDetails(subId);
    this.getClientSettings(this.state.clientId);
  }

  candInfoCallback = (candidateInfo) => {
    this.setState({
      candidateEmail: candidateInfo.email,
      candidateName: candidateInfo.name,
      candidatePhoneNumber: candidateInfo.phoneNumber,
      candidateMobileNumber: candidateInfo.mobileNumber,
      candidateAddress: this.createAddress(candidateInfo.address)
    });
  };

  createAddress = (data:any) => {
    let address = "";
    if (data.addressLine1 != null && data.addressLine1?.trim() != ""){
        address += `${data.addressLine1}, `
    }
    if (data.addressLine2 != null && data.addressLine2?.trim() != ""){
        address += `${data.addressLine2}, `
    }
    if (data.city != null){
        address += `${data.city.name}, `
    }
    if (data.state != null){
        address += `${data.state.name}, `
    }
    if (data.pinCodeId != null){
        address += `${data.pinCodeId}`
    }

    return address;
  }

  getCandSubPresentationInfo = (candSubmissionId: string) => {
    this.setState({ showLoader: true });
    axios
      .get(`api/candidates/workflow/${candSubmissionId}/presentationinfo`)
      .then((result:any) => {
        if (result != null && result.data != "") {
          this.setState({
            isRateLockdownAccepted: result.data.isRateLockdownAccepted
          });
        }
      });
  };

  async getCandidateSubmissionDetails(candSubmissionId) {
    this.setState({ showLoader: true });
    await axios
      .get(`api/candidates/workflow/${candSubmissionId}`)
      .then((res:any) => {
        this.setState({
          reqId: res.data.reqId,
          reqStartDate:localDateTime(res.data.reqStartDate),
          candSubDetails: res.data,
          candidateId: res.data.candidateId,
          status: res.data.status,
          statusIntId: res.data.statusIntId,
          positionId: res.data.positionId,
          jobPositionId: res.data.jobPositionId,
          locationId: res.data.locationId,
          divisionId: res.data.divisionId,
          reqNo: res.data.reqNumber,
          location: res.data.location,
          position: res.data.position,
          jobWfTypeId: res.data.jobWfTypeId,
          //targetStartDate: res.data.targetStartDate,
          //targetEndDate: res.data.targetEndDate,
          reqEndDate: localDateTime(res.data.reqEndDate),
          showLoader: false,
          targetStartDate: res.data.targetStartDate != null && res.data.targetStartDate != undefined && res.data.targetStartDate != "" 
          ? localDateTime(res.data.targetStartDate) : res.data.targetStartDate,
          targetEndDate: res.data.targetEndDate != null && res.data.targetEndDate != undefined && res.data.targetEndDate != "" 
          ? localDateTime(res.data.targetEndDate) : res.data.targetEndDate,
          isPilot: res.data.isPilot,
          submittedVendorId: res.data.submittedVendorId,
          reqCreatedDate: res.data.reqCreatedDate
        }, () => this.getLetterAndForecastStatusInWf()
        );
      });
  }

  getLetterAndForecastStatusInWf = () => {
    const {jobWfTypeId} = this.state;
    if (jobWfTypeId != undefined){
      CommonDataService.getLetterOrForecastStatusInWf(jobWfTypeId)
          .then((data:any) => {console.log(data, data.isForecast); this.setState({
            isForecastEnableInWf: data.isForecast
          })}
      );
    }
  }

  handleDisable = () => { }

  handleEnable = () => { }

  validateTargetDates = () => {
    const { isForecastEnableInWf } = this.state;
    var showError = this.state.isAssignmentProjections == true && isForecastEnableInWf && (this.state.targetStartDate === null ||
                  this.state.targetEndDate === null) ? true : false;
    this.setState({ targetDateError: showError });
    return showError;
  }

  validateSubmission = (action, nextStateId?, eventName?, actionId?) => {
    this.action = action;
    this.statusId = nextStateId;
    this.eventName = eventName;
    this.actionId = actionId;
    const {
      showErrors,
      presentationInfoDetails,
    } = refCandSubPresentation.current.validateField();
    let billRateValidate = billRateRef.current.validateBillRatesData();
    let targetDateError = this.validateTargetDates();
    const {
      showDistanceError,
      distanceDetails,
    } = refCandDistance?.current?.validateDistance(false, targetDateError, showErrors, billRateValidate);
    if (action == "Submit") {
      if (showErrors || billRateValidate || targetDateError || showDistanceError) return false;
    }

    if (action == "Submit") {

      if (!billRateValidate && !showErrors) {
        this.setState({ showSubmitModal: true });
        this.action = action;
        this.statusId = nextStateId;
        this.eventName = eventName;
      }
    }
    else if (action == "Withdraw") {
      this.setState({ showWithdrawModal: true })
    }
    else if (action == "Reject Candidate") {
      this.setState({ showRejectCandidateModal: true })
    }
    else {
      this.savePresentation(action, nextStateId, eventName);
    }
  };

  savePresentation = (action, nextStateId?, eventName?, isOverriden?) => {
    const {
      showErrors,
      presentationInfoDetails,
    } = refCandSubPresentation.current.validateField();
    let targetDateError = this.validateTargetDates();
    const {
      showDistanceError,
      distanceDetails,
    } = refCandDistance?.current?.validateDistance(isOverriden, targetDateError, showErrors);

    if (action == "Submit") {
      if (showErrors || targetDateError || showDistanceError) return false;
    }

    if (presentationInfoDetails.potentialStartDate != null && presentationInfoDetails.potentialStartDate != undefined) {
      presentationInfoDetails.potentialStartDate = localDateTime(presentationInfoDetails.potentialStartDate);
    }

    let data = {
      candSubmissionId: this.state.candSubmissionId,
      statusId: nextStateId,
      isSubmit: false,
      eventName: eventName,
      actionId: this.actionId,
      targetStartDate: null,
      targetEndDate: null,
      isRateLockdownAccepted: this.state.isRateLockdownAccepted,
      ...presentationInfoDetails,
      distanceFromLoc: distanceDetails.distance
    };

    if (this.state.targetStartDate != null && this.state.targetStartDate != undefined) {
      data.targetStartDate = localDateTime(this.state.targetStartDate);
    }

    if (this.state.targetEndDate != null && this.state.targetEndDate != undefined) {
      data.targetEndDate = localDateTime(this.state.targetEndDate);
    }

    data["isOverride"] = isOverriden;

    data["isSubmit"] = action == "Submit" && (isOverriden == false || isOverriden == undefined) ? true : false;
    const successMsg = data["isSubmit"]
      ? PRESENTATION_SUBMIT_SUCCESS_MSG
      : this.state.showAlertForDistance == true ? REQUEST_SENT_FOR_OVERRIDE : PRESENTATION_SAVE_SUCCESS_MSG;
    let httpVerb = data.candSubPresentationInfoId ? "put" : "post";
    axios[httpVerb](
      "api/candidates/presentationinfo",
      JSON.stringify(data)
    ).then((res) => {
      successToastr(successMsg);
      if (auth.hasPermissionV2(AppPermissions.CANDIDATE_UPDATE)) {
        this.setState({showSubmitModal:false, showAlertForDistance: false});
        // history.push(`${CAND_SUB_MANAGE_URL}${this.state.reqId}`);
        history.goBack()
      } else {
        window.location.href = APP_HOME_URL;
      }
    }).catch(err => {
      this.setState({ showSubmitModal: false, showAlertForDistance: false });
    });
  };

  candidateStatusUpdate = (successMsg, modal, props?) => {
    this.setState({ showLoader: true });
    const data = {
      candSubmissionId: this.state.candSubmissionId,
      statusId: this.statusId,
      eventName: this.eventName,
      actionId: this.actionId,
      ...props,
    };
    axios.put("api/candidates/workflow/status", JSON.stringify(data)).then((res) => {
      successToastr(successMsg);
      this.setState({ showLoader: false });
      if (auth.hasPermissionV2(AppPermissions.CANDIDATE_UPDATE)) {
        // history.push(`${CAND_SUB_MANAGE_URL}${this.state.reqId}`);
        history.goBack()

      } else {
        window.location.href = APP_HOME_URL;
      }
    });
    // close the modal
    let change = {};
    change[modal] = false;
    this.setState(change);

  };

  handleChange = (e) => {
    let change = { isDirty: true };
    change[e.target.name] = e.target.value;
    this.setState(change);
  };

    getClientSettings = (clientId) => {
        getClientSettingsData(clientId).then((res) => {

            applySettingFilters(res, SettingCategory.REPORT, SETTINGS.ASSIGNMENT_PROJECTION, (response) => {
                this.setState({ isAssignmentProjections: response });
            });

            applySettingFilters(res, SettingCategory.CANDIDATE, SETTINGS.RATE_LOCKDOWN, (response) => {
                this.setState({ isRateLockdown: response }, () => {
                    applySettingFilters(res, SettingCategory.CANDIDATE, SETTINGS.GENERAL_RELEASE_EFFECTIVE_DATE, (response) => {
                        this.setState({ generalReleaseEffectiveDate: response }, () => {
                            if (isRateLockdown(this.state.isRateLockdown, this.state.generalReleaseEffectiveDate, this.state.reqCreatedDate, this.state.isPilot, false) && this.state.isRateLockdownAccepted == false) {
                                this.alertTitle = AlertBoxTitle.VENDOR_PRESENTATION_ALERT;
                                this.setState({ openAlert: true });
                            }
                        });
                    });
                });
            });

            applySettingFilters(res, SettingCategory.CANDIDATE, SETTINGS.RATE_LOCKDOWN_WARNING_MESSAGE, (response) => {
                this.setState({ alertMessage: response });
            });
        });
  };

  candPresentationInfoCallback = (distance, isOverride, candSubPresentationInfoId) => {
    this.setState({
        distanceFromLocation : distance,
        isOverride: isOverride,
        candPresentationInfoId: candSubPresentationInfoId
    })
  }

  handleAlertBox = () => {
    if (this.action == "Submit"){
      this.setState({ showAlertForDistance: true });
    }
  }

  updateCandSubPresentation = (approved, rejected) => {
      if (rejected && (this.state.approversComments == undefined || this.state.approversComments == "")){
          return false;
      }

      this.setState({ showLoader: true });
      const { distanceDetails } = refCandDistance.current.getDistance();

      var data = {
        candSubmissionId: this.state.candSubmissionId,
        CandSubPresentationInfoId: this.state.candPresentationInfoId,
        rejected: rejected,
        approved: approved,
        comment: this.state.approversComments,
        jobWfTypeId: this.state.jobWfTypeId,
        currentState: this.state.status,
        distanceFromLoc: distanceDetails.distance
      }
  
      let successMsg = approved === true ? REQUEST_TO_OVERRIDE_APPROVED : REQUEST_TO_OVERRIDE_REJECTED;
      
      axios.put("api/candidates/submitPresentation/request", JSON.stringify(data)).then((res) => {
        successToastr(successMsg);
        this.setState({ showLoader: false, showApprovalModal: false, showRejectModal: false });
        history.goBack()
      });
  }

  commentsChange = (e) => this.setState({ approversComments: e.target.value, approversCommentError: e.target.value == ""});

  handleChangeApproval = (isApproved, isRejected) => {
    if (isApproved == true){
      this.setState({ showApprovalModal: true })
    }
    if (isRejected == true){
      this.setState({ showRejectModal: true })
    }
  }

  handleCheckboxChange = (e, modelProp) => {
      var stateObj = {};
      stateObj[modelProp] = e.target.type == "checkbox" ? e.target.checked : e.target.value;
      this.setState(stateObj);
  }

  render() {
    const {
      candSubDetails,
      targetStartDate,
      targetEndDate,
      isAssignmentProjections,
      targetDateError,
      isForecastEnableInWf
    } = this.state;

    const projectionInfo = {
      targetStartDate,
      targetEndDate,
      candSubDetails,
      targetDateError
  };
  console.log(isForecastEnableInWf, isAssignmentProjections);
    return (
      <React.Fragment>
        <div className="col-11 mx-auto pl-0 pr-0 mt-3">
          <div className="col-12 p-0 shadow pt-1 pb-1">
            <PageTitle
              title="Vendor Presentation"
              reqNumber={this.state.reqNo}
              candSubmissionId={this.state.candSubmissionId}
              pageUrl={`/requisitions/view/${this.state.reqId}`}
            />
            <div className="col-12">
              <Collapsible
                trigger={candTriggerName(
                  "Candidate Information",
                  this.state.status
                )}
                open={true}
              >
                {!this.state.showLoader &&
                  this.state.candSubDetails &&
                  this.state.candidateId && (
                    <CandidateInformation
                      ref={refCand}
                      callbackFromParent={this.candInfoCallback}
                      candidateId={this.state.candidateId}
                      location={this.state.location}
                      submissionData={this.state.candSubDetails}
                    />
                  )}
              </Collapsible>
              <Collapsible
                trigger={candTriggerName("Bill Rates and Expenses")}
                open={true}
              >
                {this.state.candSubmissionId &&
                  this.state.candidateName &&
                  this.state.locationId &&
                  this.state.positionId && (
                    <BillRateAndExpenses
                      ref={billRateRef}
                      candSubmissionId={this.state.candSubmissionId}
                      candidateName={this.state.candidateName}
                      locationId={this.state.locationId}
                      positionId={this.state.jobPositionId}
                      divisionId={this.state.divisionId}
                      candidateSubStatusIntId={this.state.statusIntId}
                      candidateSubStatus={this.state.status}
                      handleDisable={() => this.handleDisable()}
                      handleEnable={() => this.handleEnable()}
                      isRateLockdown={this.state.isRateLockdown}
                      isPilot={this.state.isPilot}
                      location={this.state.location}
                      position={this.state.position}
                      statusIntId={this.state.statusIntId}
                      vendorId={this.state.submittedVendorId}
                      reqCreatedDate={this.state.reqCreatedDate}
                    ></BillRateAndExpenses>
                  )}
              </Collapsible>
              <Collapsible
                trigger={candTriggerName("Presentation Information")}
                open={true}
              >
                {this.state.candSubmissionId &&
                  this.state.candidateName && this.state.reqStartDate&&
                  (
                    <CandSubPresentationInfo
                      candidatePhoneNumber={this.state.candidateMobileNumber ? this.state.candidateMobileNumber : this.state.candidatePhoneNumber}
                      candidateEmail={this.state.candidateEmail}
                      ref={refCandSubPresentation}
                      candSubmissionId={this.state.candSubmissionId}
                      isEnable={true}
                      reqStartDate={(this.state.reqStartDate)}
                      callbackFromCandPresentaion={this.candPresentationInfoCallback}
                      candidateSubStatusIntId={this.state.statusIntId}
                    />
                  )}
              </Collapsible>
              <Collapsible
                trigger={candTriggerName(
                  "Distance From "+ LocalizationHelper.getLocalizedTitle(LocalizationResource.Location_Label, "Location")
                )}
                open={true}
              >
                {!this.state.showLoader &&
                  this.state.candidateAddress && (
                    <CandidateDistance
                      ref={refCandDistance}
                      distanceFromLocation={this.state.distanceFromLocation}
                      providerAddress={this.state.candidateAddress}
                      locationId={this.state.locationId}
                      handleAlert={this.handleAlertBox}
                      isOverride={this.state.isOverride}
                      handleChangeApproval={this.handleChangeApproval}
                    />
                  )}
              </Collapsible>
              {this.state.statusIntId == CandSubStatusIds.PENDINGFORVENDORPRESENTATION && isAssignmentProjections == true && isForecastEnableInWf == true && (
              <Collapsible
                trigger={candTriggerName("Assignment Target Dates")}
                open={true}
              >
                {this.state.candSubmissionId && this.state.statusIntId == CandSubStatusIds.PENDINGFORVENDORPRESENTATION && isAssignmentProjections == true && isForecastEnableInWf == true && (
                    <ProjectionTargetDates
                      data={projectionInfo}
                      handleChange={this.handleChange}
                      showLoader={false}
                      generateProjection={false}
                      reqDates={{reqStartDate:this.state.reqStartDate, reqEndDate:this.state.reqEndDate}}
                    />
                  )}
              </Collapsible>
              )}
            </div>
            <hr />
            <div className="col-12 col-sm-4 col-lg-4 mt-2 mb-2 mb-sm-0  mt-sm-0">
              <label className="mb-0 font-weight-bold ">Comments</label>
              <span
                onClick={() => this.setState({ openCommentBox: true })}
                className="text-underline cursorElement align-middle"
              >
                <FontAwesomeIcon
                  icon={faClock}
                  className="ml-1 active-icon-blue ClockFontSize"
                />
              </span>
              <Comment
                entityType={EntityType.CANDSUBMISSION}
                entityId={this.state.candSubmissionId}
              />
            </div>
            {this.state.openCommentBox && (
              <CommentHistoryBox
                entityType={EntityType.CANDSUBMISSION}
                entityId={this.state.candSubmissionId}
                showDialog={this.state.openCommentBox}
                handleNo={() => {
                  this.setState({ openCommentBox: false });
                  document.body.style.position = "";
                }}
              />
            )}
          </div>
        </div>
        {this.state.status && this.state.jobWfTypeId && (
          <FormActions
            wfCode={CandidateWorkflow.CANDIDATE}
            jobWfTypeId={this.state.jobWfTypeId}
            entityId={this.state.candSubmissionId}
            currentState={this.state.status}
            handleClick={this.validateSubmission}
            // cancelUrl={`${CAND_SUB_MANAGE_URL}${this.state.reqId}`}
            handleClose={() => history.goBack()}
          />
        )}
        <ConfirmationModal
          message={PRESENTATION_CONFIRMATION_MSG}
          showModal={this.state.showSubmitModal}
          handleYes={(e) =>
            this.savePresentation(this.action, this.statusId, this.eventName)
          }
          handleNo={() => {
            this.setState({ showSubmitModal: false });
          }}
        />

        {this.state.showWithdrawModal && this.actionId && (
          <RejectModal
            action={"Withdraw"}
            actionId={this.actionId}
            message={WITHDRAW_CANDIDATE(this.state.candidateName)}
            showModal={this.state.showWithdrawModal}
            handleYes={(data) =>
              this.candidateStatusUpdate(
                WITHDRAW_CANDIDATE_SUCCESS_MSG,
                "showWithdrawModal",
                data
              )
            }
            handleNo={() => {
              this.setState({ showWithdrawModal: false });
            }}
          />
        )}
        {this.state.showRejectCandidateModal && this.actionId && (
          <RejectModal
            action={"Reject Candidate"}
            actionId={this.actionId}
            message={REJECT_CANDIDATE(null)}
            showModal={this.state.showRejectCandidateModal}
            handleYes={(data) =>
              this.candidateStatusUpdate(
                REJECT_CANDIDATE_SUCCESS_MSG,
                "showRejectCandidateModal",
                data
              )
            }
            handleNo={() => {
              this.setState({ showRejectCandidateModal: false });
            }}
          />
        )}

        {/* <AlertBox
            handleNo={() => this.setState({ showAlertForDistance: false })}
            message={INFO_MSG_FOR_MAX_DISTANCE(this.state.maxDistance)}
            showModal={this.state.showAlertForDistance}
        > */}
        <ConfirmationModal
            message={INFO_MSG_FOR_MAX_DISTANCE()}
            showModal={this.state.showAlertForDistance}
            handleYes={() => this.savePresentation(this.action, this.statusId, this.eventName, true)}
            handleNo={() => {
                this.setState({ showAlertForDistance: false });
            }}
        />

        <ConfirmationModal
          message={MSG_FOR_REJECT_OVERRIDE_REQUEST()}
          showModal={this.state.showRejectModal}
          handleYes={() => this.updateCandSubPresentation(false, true)}
          enterComments
          commentsRequired
          showError={this.state.approversCommentError}
          commentsChange={this.commentsChange}
          comments={this.state.approversComments}
          handleNo={() => {
              this.setState({ approversComments: "", showRejectModal: false });
          }}
        />

        <ConfirmationModal
          message={MSG_FOR_APPROVING_OVERRIDE_REQUEST()}
          showModal={this.state.showApprovalModal}
          handleYes={() => this.updateCandSubPresentation(true, false)}
          handleNo={() => {
              this.setState({showApprovalModal: false });
          }}
        />
        {this.state.openAlert && (
          <AlertBox
            handleNo={() => {
              this.setState({ openAlert: false });
            }}
            message={this.state.alertMessage}
            showModal={this.state.openAlert}
            acceptanceRequired={this.state.isRateLockdown}
            statusIntId={this.state.statusIntId}
            isPilot={this.state.isPilot}
            title={this.alertTitle}
            handleCheckboxChange={this.handleCheckboxChange}
            accepted={this.state.isRateLockdownAccepted}
            effectiveDate={this.state.generalReleaseEffectiveDate}
            reqCreatedDate={this.state.reqCreatedDate}
          ></AlertBox>
        )}
      </React.Fragment>
    );
  }
}

export default SubmitPresentationForm;
